import { render, staticRenderFns } from "./merchant-auth-detail.vue?vue&type=template&id=4323d0e4&scoped=true"
import script from "./merchant-auth-detail.vue?vue&type=script&lang=js"
export * from "./merchant-auth-detail.vue?vue&type=script&lang=js"
import style0 from "./merchant-auth-detail.vue?vue&type=style&index=0&id=4323d0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323d0e4",
  null
  
)

export default component.exports